import { ofType } from "redux-observable";
import { of } from "rxjs";
import { concat } from "rxjs";
import { mergeMap } from "rxjs/operators";
import normalize from "json-api-normalizer";
import { parseError } from "./lib";

import HistoryService from "../services/historyService";

import {
  LOAD_HISTORY_REQUEST_ACTION,
  loadHistorySuccess,
  loadHistoryFailure
} from "../ducks/data";

export const loadHistoryEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_HISTORY_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new HistoryService();
      return service
        .findAll(action.payload.type, action.payload.id)
        .then(response => {
          return loadHistorySuccess(normalize(response.data));
        })
        .catch(error => {
          return loadHistoryFailure(parseError(error));
        });
    })
  );



// WEBPACK FOOTER //
// ./src/epics/history.js